import {
  IPredicateOperator,
  IPredicatePolygonOperator,
  IPredicatePropertyOperator,
  IPredicateType
} from "models/filter";

export const PREDICATE_TYPE: IPredicateType = {
  Property: "Property",
  WellList: "WellList",
  Polygon: "Polygon",
  MultiPolygon: "MultiPolygon"
};

/**
 * A spatial selection predicate is either a single Polygon or, when the
 * selection has been refined into disjoint pieces by intersecting lassos, a
 * MultiPolygon. Both are handled identically throughout the filter UI.
 */
export const isPolygonPredicateType = (type?: string): boolean =>
  type === PREDICATE_TYPE.Polygon || type === PREDICATE_TYPE.MultiPolygon;

export const PREDICATE_OPERATOR: IPredicateOperator = {
  And: "and",
  Or: "or"
};
export const PREDICATE_POLYGON_OPERATOR: IPredicatePolygonOperator = {
  Equals: "=",
  NotEqual: "!="
};
export const PREDICATE_PROPERTY_OPERATOR: IPredicatePropertyOperator = {
  Between: "between",
  NotBetween: "not between",
  GreaterThan: ">",
  GreaterThanOrEqual: ">=",
  Equals: "=",
  NotEqual: "!=",
  LessThan: "<",
  LessThanOrEqual: "<=",
  In: "in",
  NotIn: "nin"
};

/**
 * The filters the system ships, by name. Named individually because more than
 * one place has to recognise a single one of them: the AWS policy reshapes two,
 * and the default-filter resolution looks up the entity default rather than
 * trusting the order the backend happens to return.
 */
export const SYSTEM_DEFAULT_FILTER_NAME = "system default";
export const HZ_WITH_PRODUCTION_FILTER_NAME = "hz with production";
export const FACILITY_DEFAULT_FILTER_NAME = "facility default";
export const ACTIVE_FILTER_NAME = "active filter";

export const SYSTEM_DEFAULT_FILTERS = [
  SYSTEM_DEFAULT_FILTER_NAME,
  HZ_WITH_PRODUCTION_FILTER_NAME,
  FACILITY_DEFAULT_FILTER_NAME,
  ACTIVE_FILTER_NAME
];

/**
 * The operators that take the wells they match out of the filter rather than
 * keeping them, beside the negated flag. Four spellings, because an exclusion
 * arrives more than one way: the flag a legend exclude sets, and the operators
 * the filter tree writes for the same thing.
 *
 * This list is the backend's, copied: its Predicate::is_exclusion names these
 * same operators, and it is what decides whether a buffer is applied. A
 * spelling missing here would be shown with a buffer the filter never ran
 * with — the chip would say "(+10 mi)" over a filter measured at the boundary.
 */
export const SUBTRACTIVE_OPERATORS: ReadonlySet<string> = new Set([
  PREDICATE_PROPERTY_OPERATOR.NotIn,
  PREDICATE_PROPERTY_OPERATOR.NotEqual,
  PREDICATE_PROPERTY_OPERATOR.NotBetween
]);
